import * as React from 'react';

export const WifiIcon: React.FunctionComponent = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 4.75295C6.15371 4.75295 4.3815 5.47915 3.06608 6.77471C2.81957 7.0175 2.42292 7.01448 2.18014 6.76797C1.93735 6.52146 1.94036 6.12481 2.18687 5.88203C3.73669 4.3556 5.8247 3.5 8 3.5C10.1753 3.5 12.2633 4.3556 13.8131 5.88203C14.0596 6.12481 14.0627 6.52146 13.8199 6.76797C13.5771 7.01448 13.1804 7.0175 12.9339 6.77471C11.6185 5.47915 9.84629 4.75295 8 4.75295Z"
        fill="#3A3A3A"
      />
      <path
        d="M4.83486 8.54841C5.68101 7.7217 6.81703 7.25886 8 7.25886C9.18297 7.25886 10.319 7.7217 11.1651 8.54841C11.4126 8.79021 11.8093 8.7856 12.0511 8.53812C12.2929 8.29064 12.2882 7.894 12.0408 7.65221C10.9605 6.59679 9.51023 6.00591 8 6.00591C6.48977 6.00591 5.03947 6.59679 3.95924 7.65221C3.71176 7.894 3.70715 8.29064 3.94894 8.53812C4.19074 8.7856 4.58738 8.79021 4.83486 8.54841Z"
        fill="#3A3A3A"
      />
      <path
        d="M6.60171 10.3253C6.97835 9.96552 7.47916 9.76477 8 9.76477C8.52085 9.76477 9.02166 9.96552 9.39829 10.3253C9.64849 10.5643 10.045 10.5552 10.284 10.305C10.523 10.0548 10.5139 9.65822 10.2637 9.41923C9.65398 8.83681 8.84321 8.51182 8 8.51182C7.15679 8.51182 6.34602 8.83681 5.73627 9.41923C5.48608 9.65822 5.47699 10.0548 5.71597 10.305C5.95496 10.5552 6.35152 10.5643 6.60171 10.3253Z"
        fill="#3A3A3A"
      />
      <path
        d="M8.83571 11.644C8.83571 12.1054 8.46174 12.4793 8.00041 12.4793C7.53909 12.4793 7.16511 12.1054 7.16511 11.644C7.16511 11.1827 7.53909 10.8087 8.00041 10.8087C8.46174 10.8087 8.83571 11.1827 8.83571 11.644Z"
        fill="#3A3A3A"
      />
    </svg>
  );
};
